/* @jsxImportSource react */

import * as React from 'react';
import { PriceOldPrice } from '../PriceOldPrice/PriceOldPrice';
import { PriceReductionFlag } from '../PriceReductionFlag/PriceReductionFlag';

export interface PriceDiscountProps
  extends React.HTMLAttributes<Omit<HTMLDivElement, 'className'>> {
  oldPrice: string;
  oldPriceAriaLabel?: string;
  discount?: string;
  discountAriaLabel?: string;
}

const PriceDiscount = ({
  oldPrice,
  discount,
  oldPriceAriaLabel,
  discountAriaLabel,
  ...props
}: PriceDiscountProps) => (
  <div className="price-discount flex [grid-area:b]" {...props}>
    {oldPriceAriaLabel && <span className="sr-only">{oldPriceAriaLabel}</span>}
    <PriceOldPrice>{oldPrice}</PriceOldPrice>
    {discount && (
      <>
        {discountAriaLabel && <span className="sr-only">{discountAriaLabel}</span>}
        <PriceReductionFlag>{discount}</PriceReductionFlag>
      </>
    )}
  </div>
);

PriceDiscount.displayName = 'Price.Discount';

export { PriceDiscount };
